import { useRef, useState, useEffect } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Icon } from "@iconify/react";
import CustomPopoverSectionItems from "./CustomPopOverSectinItems";
import MenuPopover from "../popUp/MenuPopOver";
import { Tooltip } from "@mui/material";

export default function CustomPopoverSection({
  menu,
  data,
  color,
  custom_icon,
  custom_icon_height = 20,
}) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [popoverWidth, setPopoverWidth] = useState(0);

  useEffect(() => {
    // console.log(data, "value of data.....");
  }, []);

  const handleOpen = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setOpen(false);
  };

  function calculateMaxLabelLength(data) {
    let maxLetters = 0;
    data.forEach((item) => {
      const labelLength = item.label.length;
      if (labelLength > maxLetters) {
        maxLetters = labelLength;
      }
    });
    return maxLetters;
  }

  useEffect(() => {
    if (menu.length > 8) {
      const maxLabelLength = calculateMaxLabelLength(menu);
      setPopoverWidth(maxLabelLength * 9.2 + 34);
    }
  }, []);

  return (
    <div
      style={{ cursor: "pointer" }}
      className="remove-border menu-background-circle"
    >
      {custom_icon ? (
        <img
          style={{
            cursor: "pointer",
            fill: color,
            height: custom_icon_height,
          }}
          className="pointer custom-popover-icon"
          ref={anchorRef}
          onClick={handleOpen}
          src={custom_icon}
        ></img>
      ) : (
        <MoreVertIcon
          style={{
            cursor: "pointer",
            fontSize: 20,
            fill: color,
          }}
          className="pointer custom-popover-icon"
          ref={anchorRef}
          onClick={handleOpen}
        />
      )}
      <MenuPopover
        className="custom-popover"
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{
          marginLeft: 1.8,
          maxHeight: 300,
          minWidth: 2,
          width: popoverWidth ? popoverWidth : "auto",
          "&::-webkit-scrollbar": {
            width: "5px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555",
          },
        }}
      >
        {/* {menu.length > 8 && (
          <div
            className="menu-search-box"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
            }}
          >
            <Icon
              fontSize={20}
              className="menu-search-icon"
              icon="akar-icons:search"
            />
            <input
              className="menu-search-input"
              type="text"
              placeholder="Search"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>
        )} */}
        {menu
          .filter((option) =>
            option.label.toLowerCase().includes(searchInput.toLowerCase())
          )
          .map((option, idx) => {
            const isDisabled = option.disabled;
            return (
              <Tooltip
                key={option.id || idx}
                title={isDisabled && option.tooltip ? option.tooltip : ""}
                placement="left"
                arrow
                disableHoverListener={!isDisabled}
              >
                <div
                  style={{
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    // pointerEvents: "auto" // always allow pointer events for tooltip
                  }}
                  tabIndex={0} // make it focusable for tooltip
                >
                  <span
                    style={{
                      pointerEvents: isDisabled ? "none" : "auto",
                      display: "block",
                    }}
                  >
                    <CustomPopoverSectionItems
                      item={option}
                      data={data}
                      setOpen={setOpen}
                      disabled={isDisabled}
                      tooltip={option.tooltip}
                    />
                  </span>
                </div>
              </Tooltip>
            );
          })}
      </MenuPopover>
    </div>
  );
}
